import { useEffect } from "react";
import Block from "@material-ui/icons/Block";
import { useBreadcrumbs } from "../../../contexts/breadcrumb";
import { useCancellationCreate } from "../../../services/api-tansquery/cancellation/create";
import Form from "./form";

export default function AppointmentCancellationFormCreate() {
    const { setBreadcrumbs } = useBreadcrumbs();
    const mutation = useCancellationCreate();

    useEffect(() => {
        setBreadcrumbs((prev) => {
            const homeBreadcrumb = prev.find((_, index) => index === 0);
            return [
                homeBreadcrumb,
                {
                    label: "Cancelamentos",
                    path: "/cancelamentos",
                    icon: Block,
                },
                {
                    label: "Gerenciar",
                    path: "",
                },
            ];
        });
    }, [setBreadcrumbs]);

    return (
        <Form
            mutation={mutation}
        />
    );
}